export class Condition {
    'property';
    'operator';
    'value';
    'conditions';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "property",
            "baseName": "property",
            "type": "string",
            "format": ""
        },
        {
            "name": "operator",
            "baseName": "operator",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "conditions",
            "baseName": "conditions",
            "type": "Array<Condition>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Condition.attributeTypeMap;
    }
    constructor() {
    }
}
